import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { asset } from "../../Services/BaseHelpers";
import PageHeader from "../../Components/Utilities/PageHeader";
import Section from "../../Components/Utilities/Section";
import { Link, MailLink } from "../../Components/Utilities";
import QuestionSection from "../../Components/Utilities/QuestionSection";

export default class CapeTown extends React.Component {
    render () {
        return (
            <Authenticated title="Cape Town">
                <PageHeader
                   title={"Cape Town"}
                   imgSrc={'cape-town-hero.png'}
                />
                {this.renderOpeningTextSection()}
                {this.renderIconGridSection()}
                {this.renderPicturesSection()}

                <QuestionSection />
            </Authenticated>
        );
    }

    renderOpeningTextSection () {
        return (
            <Section>
                <p className={"bmw-condenced-bold text-2xl"}>
                    EVERYTHING YOU NEED TO KNOW ABOUT THE DESTINATION
                </p>
                <p className={"bmw-light"}>
                    Cape Town is one of South Africa's three capital cities, serving as the seat of the Parliament of South Africa.
                    It is the legislative capital of the country, the oldest city in the country, and the second largest
                    (after the city Johannesburg).
                </p>
                <p className={"bmw-light"}>
                    Located on the shore of Table Bay, the central area of Cape Town is the oldest urban area in the Western Cape,
                    with a significant cultural heritage. It was founded by the Dutch East India Company (VOC) as a supply station for Dutch ships sailing to East Africa,
                    India, and the Far East.
                    Jan van Riebeeck's arrival on 6 April 1652 established the VOC Cape Colony, the first permanent European settlement in South Africa.
                </p>
                <p className={"bmw-light"}>
                    The city is known for its harbour, for its beautifully natural setting in the Cape Floristic Region,
                    and for landmarks such as Table Mountain (a must for first time visitors),
                    Robben Island (where Nelson Mandela was imprisoned) and Cape Point.
                </p>
                <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4 bmw-light text-sm text-left"}>
                    <div>
                        <p className={"bmw-bold"}>ENTRY</p>
                        There are no entry restrictions when travelling from the UK to South Africa
                    </div>
                    <div>
                        <p className={"bmw-bold"}>CURRENCY</p>
                        South African Rand is the official currency of South Africa.
                    </div>
                    <div>
                        <p className={"bmw-bold"}>PASSPORTS/VISAS</p>
                        All travellers are required to present a valid passport in order to enter South Africa.
                        Passport must still be valid for six months from the date you arrive and needs to have at least two blank pages.
                        An entry visa may be required by certain nationalities or in certain circumstances.
                        For more up-to-date information on visa requirements,
                        please click
                        {" "}
                        <a href={"http://www.dha.gov.za/index.php/applying-for-sa-visa"} className={"text-app-bmw-blue"} target={"_blank"}>
                            here
                        </a>
                    </div>
                    <div>
                        <p className={"bmw-bold"}>WEATHER</p>
                        Cape Town enjoys a four season Mediterranean climate with mild winters and warm summers.
                        April temperatures range from an average of 15°C to 23°C with slightly lower than average windspeeds and rainfall.
                    </div>
                    <div>
                        <p className={"bmw-bold"}>TIME ZONE</p>
                        In April Cape Town, South Africa will be one hour ahead the UK (GMT +1).
                    </div>
                    <div>
                        <p className={"bmw-bold"}>LANGUAGE</p>
                        English is the primary language spoken in Cape Town, followed closely by Afrikaans.
                    </div>
                    <div>
                        <p className={"bmw-bold"}>ELECTRICITY</p>
                        In South Africa there are several plug types see image below. The country operates on a 230V supply voltage and 50Hz. Adaptors can be purchased online and are available at the hotel.
                        <img  src={ asset ( 'images/electicity.png' ) } />
                    </div>
                </div>
            </Section>
        )
    }
    renderIconGridSection () {
        return (
            <div className="bg-event">
                <Section>
                    <div className={"grid grid-cols-1 lg:grid-cols-3 gap-10 "}>
                        <div className={"flex flex-col text-white justify-self-center  justify-center w-18"}>
                            <div className={"w-full justify-center "}>
                                <img  src={ asset ( 'images/population.png' ) } />
                            </div>
                            <div className={" w-full justify-center bmw-bold uppercase text-sm mt-4"}>population</div>
                            <div className={"w-full justify-center  bmw-light text-xs"}>50,709,528</div>
                        </div>
                        <div className={"flex flex-col text-white my-auto mx-auto w-16"}>
                            <img src={ asset ( 'images/capital.png' ) } />
                            <div className={"bmw-bold uppercase text-sm mt-4"}>capital</div>
                            <div className={"bmw-light text-xs"}>Pretoria</div>
                        </div>
                        <div className={"flex flex-col text-white my-auto mx-auto w-24"}>
                            <img src={ asset ( 'images/language.png' ) } />
                            <div className={"bmw-bold uppercase text-sm mt-4"}>language</div>
                            <div className={"bmw-light text-xs"}>ZULU, XHOSA, AFRIKAANS, ENGLISH</div>
                        </div>
                        <div className={"flex flex-col text-white my-auto mx-auto w-16"}>
                            <img src={ asset ( 'images/currency.png' ) } />
                             <div className={"bmw-bold uppercase text-sm mt-4"}>currency</div>
                            <div className={"bmw-light uppercase text-xs"}>South African Rand</div>
                        </div>
                        <div className={"flex flex-col text-white my-auto mx-auto w-16"}>
                            <img src={ asset ( 'images/time_difference.png' ) } />
                             <div className={"bmw-bold uppercase text-sm mt-4"}>Time Difference</div>
                            <div className={"bmw-light uppercase text-xs"}>GMT+1</div>
                        </div>
                        <div className={"flex flex-col text-white my-auto mx-auto w-16"}>
                            <img src={ asset ( 'images/best_time.png' ) } />
                            <div className={"bmw-bold uppercase text-sm mt-4"}>Best Time</div>
                            <div className={"bmw-light uppercase text-xs"}>November to May</div>
                        </div>
                    </div>
                </Section>
            </div>
        )
    }
    renderPicturesSection () {
        return (
            <Section>
                <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4"}>
                    <div>
                        <img className={"mx-auto my-auto  h-72"} src={ asset ( 'images/cape_town_section.png' ) } />
                    </div>
                    <div>
                        <img className={"mx-auto my-auto  h-72"} src={ asset ( 'images/sunset.png' ) } />
                    </div>
                </div>
            </Section>
        )
    }
}
